import React from 'react';

import { useDispatch } from 'react-redux';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';

import { addNotificationAction } from '../../action/notifications/notifications';

import { ProductTelemetryController } from '../../product-telemetry/product-telemetry-controller';

type InputProps = {
  clearForUser?: User;
  icon?: React.ReactNode;
};

export const ClearFeatureGateCacheMenuItem = (props: InputProps) => {
  const { clearForUser, icon } = props;
  const dispatch = useDispatch();

  const label = clearForUser ? 'Clear FF Cache' : 'Clear FF Cache All Users';
  const handleClearCacheClick = () => {
    ProductTelemetryController.bustFeatureGateCache(clearForUser?.username).then((response) => {
      dispatch(
        addNotificationAction({
          key: `bust-feature-gate-cache${clearForUser ? 'for-user' : 'forAllUsers'}`,
          message: `${
            response?.ok ? 'Successfully cleared' : 'Failed to clear'
          } feature gate cache for ${
            clearForUser ? `${clearForUser.firstName} ${clearForUser.lastName}` : 'all users'
          }`,
        }),
      );
    });
  };

  return (
    <MenuItem onClick={handleClearCacheClick}>
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      <ListItemText primary={label} />
    </MenuItem>
  );
};
